var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"preview-wrapper"},[_c('iframe',{staticClass:"preview-content",attrs:{"src":_vm.url,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }